import React, { Component } from "react";
import JotformEmbed from "react-jotform-embed";
import chat from "../assets/chat.svg";
import axios from "axios";
import OurTeam from "./OurTeam.js";
import SimpleMap from "./SimpleMap";

export default class Blank extends Component {
  constructor() {
    super();
    this.state = {
      data: null
    };
  }
  componentDidMount() {
    const SITE_URL = "https://oncourse.dev-ggmm.com";

    axios.get(SITE_URL + "/wp-json/wp/v2/pages?slug=company").then(res => {
      this.setState(
        {
          data: res.data[0].acf
        },
        () => window.scrollTo(0, 0)
      );
    });
  }
  render() {
    const { data } = this.state,
      id = window.location.pathname;

    if (data) {
      return (
        <div className="contact wrapper">
          <div className="jothead">
            <img src={chat} alt="Contact Us" />
            <h2>Contact Us</h2>
            <p>
              Have a question or want to know more about our solutions or
              company? Fill out the form below and we’ll get back to you ASAP
            </p>
          </div>
          <div className="form">
            <JotformEmbed src="https://form.jotform.com/91536465058160" />
          </div>
          {id === "/contact" && (
            <div>
              <OurTeam data={data} />
              <SimpleMap />
            </div>
          )}
        </div>
      );
    } else return false;
  }
}



// WEBPACK FOOTER //
// ./src/components/Contact.js